import React from "react";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

const RegistrationSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="auth-page flex-center-center">
      <div className="auth-box shadow">
        <h1>{t("konto_zostalo_pomyslnie_zalozone")}</h1>
        <p className="auth-description">{t("dziekujemy_za_zalozenie_konta")}</p>

        <div className="flex-center-center mt-4">
          <EAButton variant="filled" fullWidth title={t("zaloguj_sie")} onClick={() => navigate(LOGIN_PAGE)} />
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
